export const common = {
  perMonth: '/mese',
  perYear: '/anno',
  buyNow: 'Acquista Ora',
  viewMore: 'Scopri di Più',
  getQuote: 'Richiedi Preventivo'
};